import {useSlotProps as $aYQyM$useSlotProps, useStyleProps as $aYQyM$useStyleProps, viewStyleProps as $aYQyM$viewStyleProps, useDOMRef as $aYQyM$useDOMRef, ClearSlots as $aYQyM$ClearSlots} from "@react-spectrum/utils";
import {filterDOMProps as $aYQyM$filterDOMProps} from "@react-aria/utils";
import $aYQyM$react, {forwardRef as $aYQyM$forwardRef} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $b9606c0c41d55371$export$27a5bd065ad55220 = /*#__PURE__*/ (0, $aYQyM$forwardRef)(function View(props, ref) {
    props = (0, $aYQyM$useSlotProps)(props);
    let { elementType: ElementType = 'div', children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $aYQyM$useStyleProps)(props, (0, $aYQyM$viewStyleProps));
    let domRef = (0, $aYQyM$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $aYQyM$react).createElement(ElementType, {
        ...(0, $aYQyM$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, $aYQyM$react).createElement((0, $aYQyM$ClearSlots), null, children));
});


export {$b9606c0c41d55371$export$27a5bd065ad55220 as View};
//# sourceMappingURL=View.module.js.map
